<template>
    <el-checkbox-group v-model="selectValue" @change="TableChange" style="display: grid; grid-template-columns: repeat(6, 1fr);">
        <el-checkbox v-for="(item, idx) in table" :key="idx" :label="item.id">{{ item.name }}</el-checkbox>
    </el-checkbox-group>
</template>
<script>
export default {
    props: {
        value: {
            type: [Array],
            default: null
        },
        model: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            table: [],
                        order: {
                method: 'desc',
                column: 'id'
            },
            selectValue: []
        }
    },
    watch: {
        'model': {
            handler() {
                this.TableSearch()
            },
            immediate: true
        },
        value: {
            handler(val) {
                this.selectValue = val ?? []
            },
            immediate: true
        }
    },
    methods: {
        TableSearch() {
                        this.loading = true
            this.$http.post(
                '/9api/data-dict/search-model',
                {
                    search: { model: this.model },
                    order: this.order
                }
            ).then(rps => {
                                this.table = rps.data
                                this.loading = false
            })
        },
        TableChange(val) {
            this.$emit('input', val)
            this.$emit('onChange', val)
        }
    }
}
</script>